import { css } from '@emotion/react';

export const divider = (top, bottom, vertical) => css`
  margin: ${vertical ? `0 ${bottom}px 0 ${top}px` : `${top}px 0 ${bottom}px`};
  width: ${vertical ? '1px' : '100%'};
`;
